document.addEventListener('turbolinks:load', () => {
    const guidedStationSelectPreview = document.getElementById('guidedStationSelectPreview')
    const guideGuestPreviewScreen = document.getElementById('guideGuestPreviewScreen')
    const sgScreen = document.getElementById('sgScreen')

    const stationScrollList = document.getElementById('stationScrollList')
    const guideStationListTopBar = document.getElementById('guideStationListTopBar')
    const guestPreviewArea = document.getElementById('guestPreviewArea')
    const guidePreviewScrollableTopBarText = document.getElementById('guidePreviewScrollableTopBarText')
    let richTextAreas

    const guidedStationListAreaClickable = document.getElementsByClassName('guidedStationListAreaClickable')
    const guidedStationListAreaStations = document.getElementsByClassName('guidedStationListAreaStations')

    const guidePreviewDetailedWebsite = document.getElementById('guidePreviewDetailedWebsite')
    const guidePreviewDetailedWebsiteHolder = document.getElementById('guidePreviewDetailedWebsiteHolder')


    if (guidedStationSelectPreview !== null && sgScreen !== null && guideGuestPreviewScreen !== null &&
        guidePreviewScrollableTopBarText !== null && guestPreviewArea !== null && stationScrollList !== null &&
        guideStationListTopBar !== null) {

        richTextAreas = sgScreen.getElementsByClassName("trix-content")
        resize()
        handleScroll()
        init_areas()
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const guestPreviewHeight = guideGuestPreviewScreen.getBoundingClientRect().height

            // trix
            for (let richTextArea of richTextAreas) {

                //TODO: prüfen ob h1 angepasst werden muss
                if (richTextArea.parentNode.classList.contains('guideGuestPreviewDetailedText')) {
                    // guide guest preview
                    richTextArea.style.fontSize = `${guestPreviewHeight / 20}px`
                    richTextArea.style.lineHeight = `${guestPreviewHeight / 14}px`
                    const h1s = richTextArea.getElementsByTagName('h1')
                    for (let h1 of h1s) {
                        h1.classList.add('font-bold')
                        h1.style.fontSize = `${guestPreviewHeight / 14}px`
                    }
                } //other case can only appear in station_detail_screen.js
            }

            handleTourNameScroll()

            if (guidePreviewDetailedWebsite !== null && guidePreviewDetailedWebsiteHolder !== null) {
                resizeIframe()
            }
        })
        resizeObserver.observe(sgScreen);
    }

    function resizeIframe() {
        const guestPreviewHeightScale = guidePreviewDetailedWebsiteHolder.getBoundingClientRect().height/5.684438040345821
        guidePreviewDetailedWebsite.style.transform = `scale(${guestPreviewHeightScale}%)`
        guidePreviewDetailedWebsite.style.transformOrigin = '0 0'
        guidePreviewDetailedWebsite.style.height = `${1/(guestPreviewHeightScale/100) * 100}%`
    }

        // handle scroll of tour name
    function handleTourNameScroll() {
        const offsetHeight = guidePreviewScrollableTopBarText.offsetHeight
        const lineHeight = parseInt(getComputedStyle(guidePreviewScrollableTopBarText).lineHeight)
        const lines = offsetHeight/lineHeight

        // only scroll if there are more than 3 lines
        if (lines > 3) {
            guidePreviewScrollableTopBarText.classList.add('guidePreviewScrollableTopBarTextScroll')
            // set scroll transform-translate-X and animation speed depending on text length
            const scrollOffset = (lines-3)/(lines) *100
            const animationTime = lines-3
            guidePreviewScrollableTopBarText.style.animationDuration = `${animationTime}s`
            guidePreviewScrollableTopBarText.style.setProperty('--scrollTransformPercentage', `-${scrollOffset}%`);
        }
    }

    // change top-bar color if users scrolls
    function handleScroll() {
        stationScrollList.addEventListener("scroll", (e) => {
            if (stationScrollList.scrollTop === 0) {
                guideStationListTopBar.classList.remove('bg-extraLightBlueGuideUi')
                guideStationListTopBar.classList.add('bg-whiteGrayGuideUi')
            } else {
                guideStationListTopBar.classList.add('bg-extraLightBlueGuideUi')
                guideStationListTopBar.classList.remove('bg-whiteGrayGuideUi')
            }

        });
    }

    function init_areas(){
        for(let clickArea of guidedStationListAreaClickable){
            clickArea.addEventListener('click', ()=> {handleAreaClick(clickArea)})
        }
    }

    function handleAreaClick(area){
        if (area.dataset.click_action === "collapse"){
            hideArea(area.dataset.area_id)
            area.dataset.click_action = "expand"
        } else {
            showArea(area.dataset.area_id)
            area.dataset.click_action = "collapse"
        }
    }

    function hideArea(areaId){
        for(let station of guidedStationListAreaStations){
            if (station.dataset.areaid === areaId){
                station.classList.add('hidden')
            }
        }
        document.getElementById(`collapseArea_${areaId}`).classList.add('hidden')
        document.getElementById(`expandArea_${areaId}`).classList.remove('hidden')
    }

    function showArea(areaId){
        for(let station of guidedStationListAreaStations){
            if (station.dataset.areaid === areaId){
                station.classList.remove('hidden')
            }
        }
        document.getElementById(`collapseArea_${areaId}`).classList.remove('hidden')
        document.getElementById(`expandArea_${areaId}`).classList.add('hidden')
        handleHorizontalTextScroll(sgScreen) // The text scroll can not be handled on init, cause the element is hidden
    }

    // handle Scroll here too, because general functions only handles it on init
    function handleHorizontalTextScroll(screen) {
        // get all scrollable elements
        const texts = screen.getElementsByClassName('horizontalTextScrollMyTourAppPreview')

        if(texts.length > 0) { //only use function if there are texts
            setTimeout(function () {
                for (let text of texts) {
                    const textWidth = text.getBoundingClientRect().width
                    const parentWidth = text.parentNode.getBoundingClientRect().width
                    // enable scroll if text is longer than parent div
                    if (textWidth > parentWidth && !text.classList.contains('clone') && !text.classList.contains('cloned')) {

                        // horizontal centering of area name must be removed for smooth scrolling
                        if (text.classList.contains("areaName")) {
                            text.parentNode.classList.remove('justify-center')
                        }

                        // add empty space after text
                        text.insertAdjacentHTML('beforeend', '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp')
                        // enable scroll through class
                        text.classList.add('horizontalTextScrollMyTourAppPreviewAnimation')
                        // change animation time depending on text length
                        text.style.animationDuration = `${textWidth / 33}s`
                        // clone text to allow seamless loop
                        const clonedNote = text.cloneNode(true)
                        clonedNote.classList.add('clone')
                        text.classList.add('cloned')
                        text.parentNode.appendChild(clonedNote)
                    }
                }
            }, 1000);
        }
    }
})